export {};
//# sourceMappingURL=get-first-sample-function.js.map